import { Campaign } from '@phrasee/phrasee-typings/Graphql/interfaces'
import { parse } from 'date-fns'

// `new Date('yyyy-MM-dd')` interprets date-only strings as UTC midnight, so in
// browsers west of UTC the local date fields roll back to the previous day
// (SOL-329: calendar highlighted the day before the one selected). Parsing at
// local midnight makes the stored calendar date round-trip in any timezone.
export const parseLocalDate = (value: string): Date =>
  parse(value, 'yyyy-MM-dd', new Date())

export const shouldShowThePhraseeXIntegrationPanel = (
  campaignData: Campaign
) => {
  const { realtime_api_enabled, integration_options, testing_method } =
    campaignData?.campaign_configuration!
  return (
    !realtime_api_enabled &&
    integration_options?.type === 'sfmcv2' &&
    testing_method?.optimization_method?.selection_type === 'bandit'
  )
}
